/**
 * Instagram-konton skrivs in på fyra sätt beroende på vem som fyller i:
 *
 *   @nybergconstructa
 *   nybergconstructa
 *   instagram.com/nybergconstructa
 *   https://www.instagram.com/nybergconstructa/
 *
 * Alla fyra betyder samma konto. Utan normalisering blir länken
 * "https://@nybergconstructa" för den första varianten — en trasig länk i ett
 * dokument som går till kund.
 *
 * Vi lagrar det byggaren skrev och normaliserar här i stället, så gamla poster
 * och slarvig inmatning fungerar lika bra som en perfekt ifylld URL.
 */

/** Plockar ut kontonamnet, utan @ och utan URL-delar. Null om inget går att utläsa. */
export const instagramKonto = (varde) => {
  if (!varde || typeof varde !== 'string') return null;

  let konto = varde.trim();
  if (!konto) return null;

  // Ta bort protokoll och domän om det är en URL
  konto = konto.replace(/^https?:\/\//i, '');
  konto = konto.replace(/^www\./i, '');
  konto = konto.replace(/^instagram\.com\//i, '');

  // Ta bort inledande @ och avslutande snedstreck samt ev. frågesträng
  konto = konto.replace(/^@/, '');
  konto = konto.split(/[?#]/)[0];
  konto = konto.replace(/\/+$/, '');

  // Ett konto får bara innehålla bokstäver, siffror, punkt och understreck.
  // Blir det något annat kvar var inmatningen inte ett Instagram-konto.
  return /^[A-Za-z0-9._]+$/.test(konto) ? konto : null;
};

/** Visningsform: @konto */
export const instagramVisning = (varde) => {
  const konto = instagramKonto(varde);
  return konto ? `@${konto}` : null;
};

/** Länkmål */
export const instagramLank = (varde) => {
  const konto = instagramKonto(varde);
  return konto ? `https://instagram.com/${konto}` : null;
};
